<div class="last-available-container">
  <div class="last-available-content">
    <div *ngFor="let group of groupedObservations" class="date-group">
      <div class="group-date">
        {{ group.date | safeDate : "dd/MM/yyyy" }}
      </div>
      <div class="observations-horizontal">
        <div *ngFor="let observation of group.observations" class="observation-item">
          <app-observation-values-display [observation]="observation"></app-observation-values-display>
        </div>
      </div>
    </div>
    <div *ngIf="!observations || observations.length === 0" class="no-data">{{ "widget.noData" | translate }}</div>
  </div>
</div>
